<p-card header="iGPS Misc Info">
  <form [formGroup]="form">
    <div class="p-grid">
      <div class="form-group p-col-6">
        <label class="required" for="palletsWashed">Pallets Washed</label>
      </div>
      <div class="form-group p-col-6">
        <input type="number" pInputText class="form-control" id="palletsWashed" name="palletsWashed"
          formControlName="palletsWashed" lib-numeric>
        <error-block [field]="form.controls.palletsWashed" [messages]="{
          required: 'Pallets Washed is required.',
          numeric: 'Pallets Washed must be a number.'
        }"></error-block>
      </div>
    </div>
    <div class="p-grid">
      <div class="form-group p-col-6">
        <label class="required" for="noScanPalletsWashed">No Scan Pallets Washed</label>
      </div>
      <div class="form-group p-col-6">
        <input type="number" pInputText class="form-control" id="noScanPalletsWashed" name="noScanPalletsWashed"
          formControlName="noScanPalletsWashed" lib-numeric>
        <error-block [field]="form.controls.noScanPalletsWashed" [messages]="{
          required: 'No Scan Pallets Washed is required.',
          numeric: 'No Scan Pallets Washed must be a number.'
        }"></error-block>
      </div>
    </div>
  </form>
</p-card>
